module.exports = __webpack_public_path__ + "img/LevelNext_homeofcollegiateesports Black.107c26ae.png";